import { useEffect, useRef, useState, useContext } from 'react';

import styles from './ConferenceSettingsComponent.module.css';

import { GlobalContext } from "../../contexts/globalContext";

import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import StationListComponent from '../settings/StationListComponent';

const ConferenceSettingsComponent = ({ showSettings, openStationsMap, setOpenStationsMap, onlineDevices, setOnlineDevices, deviceToStart, setDeviceToStart, desksIdsForAnim,
    setDesksIdsForAnim, onDeskClicked }) => {

    const {
        setCurrentTopic, setTopics, setParticipantsStreams, setIamRoomAdministrator, deskData, currentParticipant, setConferencePaused, setCurrentParticipant,
        setCurrentConference, currentConference, socketRef, appHeight, setCurrentParticipantStream, setShowSettings, localSocketRef, iamSubAdministrator, setIamSubAdministrator,
        setWaitingForJoining
    } = useContext(GlobalContext)

    const shutdownAllRef = useRef();
    const powerOnAllRef = useRef();
    const emitTimeoutRef = useRef();

    const [videoArePlaying, setVideoArePlaying] = useState(false);
    const [showStartPresentation, setShowStartPresentation] = useState(false);
    const [outputVolume, setOutputVolume] = useState()
    const [inputVolume, setInputVolume] = useState()
    const [inputVolumeCurrent, setInputVolumeCurrent] = useState(10)
    const [outputVolumeCurrent, setOutputVolumeCurrent] = useState(10)
    const [allDeskIdsInRoom, setAllDeskIdsInRoom] = useState([])
    const [powerOnAllFlashing, setPowerOnAllFlashing] = useState(false)
    const [disableButtons, setDisableButtons] = useState(false)


    const [finalTranscript, setFinalTranscript] = useState("");
    const [interimTranscript, setInterimTranscript] = useState("");
    // const [sttStatus, setSttStatus] = useState("");
    const recognitionRef = useRef(null);
    const [sttStarted, setSttStarted] = useState(false);



    useEffect(() => {
        var showShutdownAll = false;
        var showPowerOnAll = false;

        for (let index = 0; index < allDeskIdsInRoom.length; index++) {
            const deviceId = allDeskIdsInRoom[index].deviceId;
            if (deviceId !== deskData.deviceId) {
                if (onlineDevices.includes(deviceId)) {
                    showShutdownAll = true;
                } else {
                    showPowerOnAll = true;
                }
            }
        }

        shutdownAllRef.current.className = showShutdownAll ? styles.on : styles.on_disabled;
        powerOnAllRef.current.className = showPowerOnAll ? styles.on : styles.on_disabled;

        if (!showPowerOnAll) setPowerOnAllFlashing(false)

        clearTimeout(emitTimeoutRef.current);

    }, [onlineDevices, allDeskIdsInRoom]);

    useEffect(() => {
        console.log("da volumele ---------------------");
        if (localSocketRef.current?.connected) {

            localSocketRef.current.emit("volume:getSpeakerMasterVolume", (volume) => {
                setOutputVolume(volume);
            });

            localSocketRef.current.emit("volume:getMicMasterVolume", (volume) => {
                setInputVolume(volume);
            });

        }

        socketRef.current.emit('GET_ALL_ONLINE_DEVICES', callback => {
            setOnlineDevices(callback);
        })

        socketRef.current.on('DEVICE_ONLINE', (onlineDevs) => {
            setOnlineDevices(onlineDevs);
        })

        socketRef.current.on('DEVICE_OFFLINE', (onlineDevs) => {
            setOnlineDevices(onlineDevs);
        })

        if (localSocketRef.current?.connected && deskData) {
            localSocketRef.current.emit("volume:reconnectDante", deskData.number);
            socketRef.current.emit("I_AM_THE_ADMIN_OF_THE_ROOM", deskData.room._id);
            setIamRoomAdministrator(true);
        }

        return () => {
            socketRef.current?.off('DEVICE_ONLINE');
            socketRef.current?.off('DEVICE_OFFLINE');
            socketRef.current?.off('MASTER_VOLUME');
            if (sttStarted) {
                recognitionRef.current.stop();
                recognitionRef.current = null;
                setSttStarted(false);
            }
        }

    }, []);

    const ShutdownAll = () => {
        for (let index = 0; index < allDeskIdsInRoom.length; index++) {
            const deviceId = allDeskIdsInRoom[index].deviceId;
            if (deviceId !== deskData.deviceId && onlineDevices.includes(deviceId)) {
                setTimeout(() => {
                    socketRef.current.emit("SHUTDOWN", deviceId);
                }, index * 200)
            }
        }
        setDesksIdsForAnim([]);
    }

    const WolAll = () => {
        for (let index = 0; index < allDeskIdsInRoom.length; index++) {
            const deviceId = allDeskIdsInRoom[index].deviceId;

            if (deviceId !== deskData.deviceId) {
                setTimeout(() => {
                    setDeviceToStart(deviceId);
                    if (localSocketRef.current?.connected) {
                        localSocketRef.current.emit("systemInfo:wakeOnLan", deviceId);
                    }
                    setDesksIdsForAnim((desksId) => [...desksId, allDeskIdsInRoom[index]._id])
                }, index * 200)
            }
        }
        setPowerOnAllFlashing(true)
    }

    useEffect(() => {
        let correctDesk = false;
        if (deskData) {
            let desk = currentConference.attachedParticipants.find(ap => ap.participant === currentParticipant?._id && ap.desk === deskData._id);
            if (desk) {
                correctDesk = true;
            }
            if (currentConference.type === "Meeting") {
                correctDesk = true;
            }
        }

        setShowStartPresentation(currentConference.status === "New" && currentParticipant?._id === currentConference.moderatedBy && correctDesk);
        setVideoArePlaying(!currentConference.videoPaused);
    }, [currentConference]);

    const StartPresentation = () => {
        setDisableButtons(true);

        setTimeout(() => {
            setDisableButtons(false);
        }, localSocketRef.current?.connected ? 12000 : 1000);

        socketRef.current.emit("START_CONFERENCE", currentConference._id, currentConference.code, null, async (data) => {
            if (!data.error) {

                socketRef.current.emit("PRESENTATION_STARTED", currentConference);

                socketRef.current.emit("GET_NEXT_OR_ACTIVE_CONFERENCE", deskData._id, (data) => {
                    if (!data.error && data.conference) {
                        if (currentConference.type !== "Meeting") {
                            setCurrentParticipant(data.participant);
                        }
                        setCurrentConference(data.conference);


                        setConferencePaused(data.conference.paused);
                    }
                });
            }
        });
    };

    const StopConference = () => {
        setDisableButtons(true);

        setParticipantsStreams([])

        if (!currentConference.videoPaused) {
            socketRef.current.emit("PAUSE_VIDEOS", currentConference._id);
        }

        setTimeout(() => {
            setTimeout(() => {
                setDisableButtons(false);
            }, localSocketRef.current?.connected ? 12000 : 1000);


            socketRef.current.emit("STOP_CONFERENCE", currentConference._id)

            if (currentConference.type === "Presentation") {
                setTimeout(() => {
                    socketRef.current.emit("CONFERENCE_ADD_ROOM_ADMIN", {
                        roomId: deskData.room._id,
                        userId: currentParticipant?._id,
                        conferenceId: currentConference._id
                    }, callback => {
                        if (!callback.error) {
                            setCurrentConference(prev => ({
                                ...prev,
                                roomAdmins: callback.response.roomAdmins
                            }))


                        } else {
                            console.log(callback.error)
                        }
                    })
                }, 600);
            }


        }, currentConference.videoPaused ? 0 : 6000);
    }

    const PauseConference = () => {
        socketRef.current.emit("PAUSE_CONFERENCE", currentConference._id);
    }

    const PlayConference = () => {
        socketRef.current.emit("PLAY_CONFERENCE", currentConference._id);
    }

    const PlayVideos = () => {
        setDisableButtons(true);
        setTimeout(() => {
            setDisableButtons(false);
        }, localSocketRef.current?.connected ? 6000 : 1000);

        if (videoArePlaying) {
            socketRef.current.emit("PAUSE_VIDEOS", currentConference._id);
        } else {
            socketRef.current.emit("PLAY_VIDEOS", currentConference._id);
        }
        setVideoArePlaying(!videoArePlaying);
    }

    const Logout = () => {
        setDisableButtons(true);
        setIamSubAdministrator(false);

        if (!currentConference.videoPaused) {
            socketRef.current.emit("PAUSE_VIDEOS", currentConference._id);
        }

        setTimeout(() => {
            setShowSettings(false);

            socketRef.current.emit("STOP_CONFERENCE", currentConference._id)

            setTimeout(() => {
                socketRef.current.emit("LOGOUT", currentParticipant?.token, () => {
                    console.log("LOGOUT");
                    setCurrentParticipant(null);
                    setWaitingForJoining(true);
                    setCurrentConference(null);
                    setConferencePaused(null);
                    setCurrentParticipantStream(null);
                    setCurrentTopic(null);
                    setTopics();
                });
            }, 300)

            setTimeout(() => {
                if (currentConference.type === "Presentation") {
                    socketRef.current.emit("PRESENTATION_EXIT", currentConference);
                } else if (currentConference.type === "Meeting") {
                    socketRef.current.emit("MEETING_EXIT", currentConference);
                }
            }, 600)
        }, currentConference.videoPaused ? 0 : 6000);
    }

    const handleChange = (event, setProgress) => {
        setProgress(event.target.value);
    }

    useEffect(() => {
        if (outputVolume && localSocketRef.current?.connected) {
            localSocketRef.current.emit("volume:setSpeakerMasterVolume", outputVolume / 100);
        }
    }, [outputVolume])

    useEffect(() => {
        if (inputVolume && localSocketRef.current?.connected) {
            localSocketRef.current.emit("volume:setMicMasterVolume", inputVolume / 100);
        }
    }, [inputVolume])

    const volumeButtonClicked = () => {
        setOutputVolumeCurrent(outputVolume);
        if (outputVolume === 0) {
            setOutputVolume(outputVolumeCurrent);
        } else {
            setOutputVolume(0);
        }
    }

    const micButtonClicked = () => {
        setInputVolumeCurrent(inputVolume);
        if (inputVolume === 0) {
            setInputVolume(inputVolumeCurrent);
        } else {
            setInputVolume(0);
        }
    }

    const StartSttConference = (lang) => {

        console.log("StartSttConference", lang);

        if (sttStarted) return;

        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            setSttStatus("Browserul nu suportă SpeechRecognition.");
            return;
        }
        // Oprim instanța anterioară dacă există deja una pornită
        if (recognitionRef.current) {
            recognitionRef.current.stop();
        }
        const recognition = new SpeechRecognition();
        recognition.lang = lang;
        recognition.continuous = true;
        recognition.interimResults = true;
        recognitionRef.current = recognition;
        recognition.onstart = () => {
            setSttStarted(true);
            console.log("Recognition started");
        };
        recognition.onresult = async (event) => {
            let interim = "";
            let newFinalText = "";
            for (let i = event.resultIndex; i < event.results.length; ++i) {
                const result = event.results[i];
                const text = result[0].transcript.trim();
                if (result.isFinal) {
                    newFinalText = text;
                    //setFinalTranscript(prev => prev + text + " \n");
                    //setFinalTranscript(text);
                } else {
                    interim += text;
                    //socketRef.current.emit("ADD_SUBTITLE", currentConference._id, interim, lang)
                }
            }
            //setInterimTranscript(interim);
            //console.log('Interim transcript:', interim);
            if (newFinalText) {
                console.log('NoutTextFinal:', newFinalText);
                socketRef.current.emit("ADD_SUBTITLE", currentConference._id, newFinalText, lang)
                //setFinalTranscript("");
                // executeTranslationPipeline(newFinalText);
            }
        };
        recognition.onerror = (event) => {
            console.error("Eroare STT:", event.error);
            if (recognitionRef.current) {
                recognitionRef.current.stop();
            }
        };
        recognition.onend = () => {
            //console.log("Final transcript:", finalTranscript);
            //socketRef.current.emit("ADD_SUBTITLE", currentConference._id, finalTranscript, lang)
            // setInterimTranscript("");
            // setFinalTranscript("");
        };
        recognition.start();
    };

    const StopSttConference = () => {
        recognitionRef.current.stop();
        setSttStarted(false);
        //setInterimTranscript("");
    }

    return (
        <div className={styles.component} style={{ left: "143px", bottom: `${showSettings ? 0 : -appHeight + 200}px`, opacity: `${showSettings ? 1 : 1}` }}>
            <div className={styles.header}>SETTINGS</div>
            <div className={styles.column} style={{ flex: "1", maxHeight: "calc(100% - 663px)" }}>
                <div className={styles.table}>
                    {deskData && <StationListComponent desksIdsForAnim={desksIdsForAnim} setDesksIdsForAnim={setDesksIdsForAnim} deviceToStart={deviceToStart} setDeviceToStart={setDeviceToStart}
                        setAllDeskIdsInRoom={setAllDeskIdsInRoom} onlineDevices={onlineDevices} onDeskClicked={onDeskClicked} setPowerOnAllFlashing={setPowerOnAllFlashing}
                        powerOnAllRef={powerOnAllRef} />}
                    <div className={styles.buttons_panel}>
                        <div className={styles.title}>POWER ON / OFF</div>
                        <div className={styles.subtitle}>Toggle the power of individual conference systems.</div>
                        <div className={styles.buttonsx}>
                            <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                                <div ref={shutdownAllRef} className={styles.on_disabled} onClick={() => ShutdownAll()}>
                                    <i className="fa-solid fa-power-off"></i>
                                    <div className={styles.text}>SHUT DOWN ALL</div>
                                </div>

                                <div ref={powerOnAllRef} className={powerOnAllFlashing ? styles.colorCycle : ""} onClick={() => WolAll()}>
                                    <i className="fa-solid fa-power-off"></i>
                                    <div className={styles.text}>POWER ON ALL</div>
                                </div>
                            </div>

                            <div className={deskData ? styles.open : styles.on_disabled} style={{ width: 267 }} onClick={() => setOpenStationsMap(!openStationsMap)}>
                                <i className="fa-solid fa-map-pin"></i>
                                <div className={styles.text}>OPEN STATIONS MAP</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.separator}></div>
            <div className={styles.column}>
                <div className={styles.sliders}>
                    <div className={styles.slider}>
                        <div className={styles.title}>SOUND</div>
                        <div className={styles.subtitle}>Adjust the volume level.</div>
                        <FontAwesomeIcon className={styles.volumeIcon} icon={byPrefixAndName.fas[outputVolume > 0 ? 'volume' : 'volume-slash']}
                            style={{ color: outputVolume > 0 ? '#181134' : '#ffffff' }} onClick={volumeButtonClicked} />
                        <input type="range"
                            className={styles.slider_input}
                            min="0"
                            max="100"
                            step="1"
                            value={outputVolume}
                            onChange={(e) => handleChange(e, setOutputVolume)}
                            style={{
                                background: `linear-gradient(to right, #726fa8 ${outputVolume}%, #726fa84D ${outputVolume}%)`
                            }}

                        ></input>
                    </div>
                    <div className={styles.slider}>
                        <div className={styles.title}>MICROPHONE</div>
                        <div className={styles.subtitle}>Adjust your microphone sensitivity.</div>
                        <FontAwesomeIcon className={styles.volumeIcon} icon={byPrefixAndName.fas[inputVolume > 0 ? 'microphone' : 'microphone-slash']}
                            style={{ color: inputVolume > 0 ? '#181134' : '#ffffff' }} onClick={micButtonClicked} />
                        <input
                            className={styles.slider_input}
                            type="range"
                            min="0"
                            max="100"
                            step="1"
                            value={inputVolume}
                            onChange={(e) => handleChange(e, setInputVolume)}
                            style={{
                                background: inputVolume > 0
                                    ? `linear-gradient(to right, #726fa8 ${inputVolume}%, #726fa84D ${inputVolume}%)`
                                    : '#726fa84D',
                            }}
                        ></input>
                    </div>
                </div>

                {!iamSubAdministrator &&
                    <div className={styles.camera_button}>
                        <div className={styles.title}>CAMERA</div>
                        <div className={styles.subtitle}>Toggle ON / OFF</div>

                        {currentConference.status === "Active" && !currentConference.paused &&
                            <div className={disableButtons ? styles.camera_inactive : styles.camera_active} onClick={() => PlayVideos()}>
                                {videoArePlaying && <i className="fa-thin fa-camera-web-slash"></i>}
                                {!videoArePlaying && <i className="fa-thin fa-camera-web" ></i>}
                                <div>{videoArePlaying ? "OFF" : "ON"}</div>
                            </div>
                        }

                        {(currentConference.status !== "Active" || currentConference.paused) &&
                            <div className={styles.camera_inactive}>
                                <i className="fa-solid fa-camera-web"></i>
                            </div>
                        }
                    </div>
                }
            </div>

            {!iamSubAdministrator &&
                <div className={styles.separator}></div>
            }

            {!iamSubAdministrator && currentConference.status === "Active" && !showSettings &&
                <div className={styles.column} style={{ position: "absolute", top: "-100px" }} >
                    <div className={styles.button} style={{ width: "425px", height: "70px", padding: "20px", backgroundColor: "#231A3E" }}>
                        {/* <div className={styles.title}>STT ROMANA</div>
                        <div className={styles.subtitle}>Start speack to text in romanian.</div> */}


                        {!sttStarted &&
                            <div className={disableButtons ? styles.inactive : styles.active} onClick={() => StartSttConference("ro-RO")} style={{ padding: "10px 5px", border: "none" }}>
                                <img style={{ borderRadius: "5px", height: "25px" }} width={25} src={process.env.REACT_APP_CMS_URL + "/assets/flags/ro.svg"} />
                                <div className={styles.text}>START STT ROMANA</div>
                            </div>
                        }

                        {sttStarted &&
                            <div className={disableButtons ? styles.inactive : styles.active} onClick={() => StopSttConference()} style={{ padding: "10px 5px", border: "none" }}>
                                <FontAwesomeIcon icon={byPrefixAndName.fas['stop']} />
                                <div className={styles.text}>STOP STT</div>
                            </div>
                        }
                    </div>
                    <div className={styles.button} style={{ width: "425px", height: "70px", backgroundColor: "#231A3E" }}>
                        {/* <div className={styles.title}>STT ENGLISH</div>
                        <div className={styles.subtitle}>Start speack to text in english.</div> */}


                        {!sttStarted &&
                            <div className={disableButtons ? styles.inactive : styles.active} onClick={() => StartSttConference("en-EN")} style={{ padding: "10px 5px", border: "none" }}>
                                <img style={{ borderRadius: "5px", height: "25px" }} width={25} src={process.env.REACT_APP_CMS_URL + "/assets/flags/us.svg"} />
                                <div className={styles.text}>START STT ENGLISH</div>
                            </div>
                        }

                        {sttStarted &&
                            <div className={disableButtons ? styles.inactive : styles.active} onClick={() => StopSttConference()} style={{ padding: "10px 5px", border: "none" }}>
                                <FontAwesomeIcon icon={byPrefixAndName.fas['stop']} />
                                <div className={styles.text}>STOP STT</div>
                            </div>
                        }
                    </div>
                </div>
            }

            {!iamSubAdministrator &&
                <div className={styles.column}>
                    <div className={styles.button} >
                        <div className={styles.title}>START / STOP</div>
                        <div className={styles.subtitle}>Begins or ends the {currentConference.type.toUpperCase()}.</div>

                        {showStartPresentation &&
                            <div className={disableButtons ? styles.inactive : styles.active} onClick={() => StartPresentation()}>
                                <FontAwesomeIcon icon={byPrefixAndName.fas['rocket-launch']} />
                                <div className={styles.text}>START {currentConference.type.toUpperCase()}</div>
                            </div>
                        }
                        {currentConference.status === "Active" &&
                            <div className={disableButtons ? styles.inactive : styles.active} onClick={() => StopConference()}>
                                <FontAwesomeIcon icon={byPrefixAndName.fas['stop']} />
                                <div className={styles.text}>STOP {currentConference.type.toUpperCase()}</div>
                            </div>
                        }
                    </div>

                    <div className={styles.button} >
                        <div className={styles.title}>PLAY / PAUSE</div>
                        <div className={styles.subtitle}>Starts or pauses the {currentConference.type.toUpperCase()}.</div>

                        {currentConference.status === "Active" && !currentConference.paused &&
                            <div className={disableButtons ? styles.inactive : styles.active} onClick={() => PauseConference()}>
                                <FontAwesomeIcon icon={byPrefixAndName.fas['pause']} />
                                <div className={styles.text}>PAUSE {currentConference.type.toUpperCase()}</div>
                            </div>
                        }

                        {currentConference.status === "Active" && currentConference.paused &&
                            <div className={disableButtons ? styles.inactive : styles.active} onClick={() => PlayConference()}>
                                <FontAwesomeIcon icon={byPrefixAndName.fas['play']} />
                                <div className={styles.text}>PLAY {currentConference.type.toUpperCase()}</div>
                            </div>
                        }

                        {currentConference.status !== "Active" &&
                            <div className={styles.inactive}>
                                <FontAwesomeIcon icon={byPrefixAndName.fas['play']} />
                                <div className={styles.text}>PLAY {currentConference.type.toUpperCase()}</div>
                            </div>
                        }
                    </div>

                    <div className={disableButtons ? styles.logout_button_inactive : styles.logout_button} onClick={() => {
                        if (!disableButtons) Logout()
                    }}>
                        END SESSION
                        <i className="fa-solid fa-arrow-right-from-bracket" style={{ fontSize: "40px", marginTop: 10 }}></i>
                    </div>
                </div>
            }
        </div>
    );
}

export default ConferenceSettingsComponent;
